import React, { Component } from "react";
import {
  Route,
  NavLink,
  BrowserRouter
} from "react-router-dom";
import App from "./App";
import Profile from "./Profile";
import Tools from "./Tools";
// <h1>Simple SPA</h1>
// <ul className="header">
//   <li><NavLink exact to="/">Home</NavLink></li>
//   <li><NavLink to="/profile">Profile</NavLink></li>
//   <li><NavLink to="/tools">Tools</NavLink></li>
// </ul>

class Main extends Component {
  render() {
    return (
      <BrowserRouter>
        <div>
          <div className="content-header">
              <h1>
                  Axie Tools
                  <small>V 1.0</small>
              </h1>
              <ol className="breadcrumb">
                  <li><a href="#"><i className="fa fa-dashboard"></i> Home</a></li>
                  <li className="active">Dashboard</li>
              </ol>
              <div className="row">
                <div className="col-md-12 external_links">
                      Useful Tools by other community dev: 
                  <a target="_blank" href="https://axie-sales.kikoweb.ch/">Axie Sales</a> |
                  <a target="_blank" href="https://freakitties.github.io/axie/jeans.html">Gene Reader</a> |
                  <a target="_blank" href="http://axiecalc.com/">Breeding Calculator</a>
                </div>
              </div>
          </div>
          <div className="content">
            <Route exact path="/" component={App}/>
            <Route path="/profile" component={Profile}/>
            <Route path="/tools" component={Tools}/>
          </div>
        </div>
      </BrowserRouter>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/Main.js